<template>
    <div
        class="md-team layout5 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle
        }"
    >
        <div class="team-container" :class="{ 'f-col': !isMobileSize }">
            <div class="module-header" :class="{ 'f-col': isMobileSize }">
                <site-title
                    :title="fmtTitle"
                />
                <div
                    class="arrow"
                    v-if="agents.length > useSlidesPerView && !isMobileSize"
                >
                    <i class="iconfont icon-arrow-up prev-el"></i>
                    <i class="split"></i>
                    <i class="iconfont icon-arrow-up next-el"></i>
                </div>
            </div>
            <swiper v-bind="options" v-if="agents.length" :class="'len-' + agents.length">
                <slide v-for="(agent, index) in agents" :key="index">
                    <AgentCard :agent="agent" :detailUrlTarget="detailUrlTarget" :theme="theme" />
                </slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import common from '../index-layout.js';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import AgentCard from '../_components/agent-card-simple.vue';
import carousel from '../carousel';
export default {
    mixins: [common, carousel],
    components: {
        AgentCard
    },
    data: function() {
        return {
            imageStyle: {},
            containerStyle: {},
            slidesPerView: 4,
            mobileSlidesPerView: 1.1
        };
    },
    computed: {
        ...mapState(usePageStore, {
            company: store => store.companyInfo
        }),
        isMobile() {
            return this.platform.isMobile;
        }
    },
    methods: {}
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-team.layout5 {
    line-height: 1.5;
    .agent {
        display: flex;
        row-gap: 20px;
        column-gap: 7.5%;
        @include media-600 {
            flex-direction: column;
        }
        @include media-min-600 {
            
            &:nth-of-type(2n + 1) {
                flex-direction: row-reverse;
            }
            &.reverse:nth-of-type(2n) {
                flex-direction: row-reverse;
            }
            &.reverse:nth-of-type(2n + 1) {
                flex-direction: row;
            }
        }
    }
    .agent + .agent {
        padding-top: 80px;
        @include media-600 {
            padding-top: 40px;
        }
    }
    .list-agent-card{
        width: 100%;
        .avatar-box-a{
            width: 100%;
            height: 380px;
            display: block;
            position: relative;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.3s ease;
            }

            .site-img-info {
                padding: 85px 20px 30px;
                display: block;
                position: absolute;
                top: 100%;
                bottom: auto;
                left: 0;
                right: 0;
                transition: all 0.3s ease;
                a {
                    word-break: break-word;
                }
            }
            &:hover {
                .site-img-info {
                    top: auto;
                    bottom: 0;
                }  
            }
        }
        .agent-info{
            text-align: center;
            
            .agent-name{
                font-family: var(--mg-title-font);
                font-size: 20px;
                color: var(--g-primary-color);
                margin-top: 20px;
                display: block;
                cursor: pointer;
            }
            .agent-position{
                font-size: 16px;
                color: var(--g-text-color);
            }
            .agent-name + .agent-position{
                margin-top: 15px;
            }
        }
    }
    .module-header{
        position: relative;
        margin-bottom: 20px;
        .arrow{
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            color: var(--g-primary-color);
            .prev-el{
                font-size: 20px;
                display: inline-block;
                transform: rotate(-90deg);
            }
            .next-el{
                font-size: 20px;
                display: inline-block;
                transform: rotate(90deg);
            }
            .split{
                display: inline-block;
                width: 52px;
            }
        }
    }
    .swiper-wrapper{
        justify-content: space-between;
    }
    .len-1{
        .swiper-wrapper{
            justify-content: center;
        }
        .swiper-slide{
            @media (min-width: 600px) {
                width: 50% !important;
                margin-right: 0px !important;
            }
            @include media-600 {
                margin-left: 0px !important;
                width: 100% !important;
                margin-right: 0px !important;
            }
        }
    }
    .len-2{
        .swiper-slide{
            @media (min-width: 600px) {
                width: 49% !important;
                margin-right: 0px !important;
            }
        }
    }
    .len-3{
        .swiper-slide{
            @media (min-width: 600px) {
                width: 32% !important;
                margin-right: 0px !important;
            }
        }
    }

    @include media-600 {
        .swiper-slide{
            &:first-child {
                margin-left: 15px;
            }
        }       
    }  
}
</style>
